import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";

const Shippingpolicy = () => {
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const hostname = window.location.hostname;
  function getBaseDomain(hostname) {
    const parts = hostname.split(".");
    if (parts.length >= 2) {
      return parts.slice(-2).join(".");
    }
    return hostname;
  }
  const handleSubscribe = (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setMessage("Please enter a valid email address.");
      return;
    }

    setMessage(
      "Thank you for subscribing! 🎉 You'll now receive our latest offers and updates."
    );
    setEmail("");
    setSubscribed(true);
  };
  const fullDomain = window.location.hostname;
  const domain = fullDomain.replace(/^www\./, "");
  return (
    <Container className="p-6 max-w-4xl mx-auto bg-white mt-3">
      <div>
        <p
          className="text-gray-800 mb-4"
          style={{ fontWeight: 600, fontSize: "18px" }}
        >
          At {domain}, we aim to provide reliable and timely delivery services
          across India.
        </p>
        <section className="mb-4">
          <h3
            className="text-gray-700"
            style={{ fontWeight: 600, fontSize: "20px" }}
          >
            Order Processing
          </h3>
          <ul className="list-disc list-inside mb-4">
            <li>
              Orders are processed within <strong>1–2 business days</strong>{" "}
              after successful order confirmation.
            </li>
            <li>
              Orders are shipped only on <strong>business days</strong> (Monday
              to Saturday, excluding public holidays).
            </li>
          </ul>
        </section>

        <section className="mb-4">
          <h3
            className="text-gray-700"
            style={{ fontWeight: 600, fontSize: "20px" }}
          >
            Delivery Timeline
          </h3>
          <ul className="list-disc list-inside mb-4">
            <li>
              Once shipped, orders are typically delivered within{" "}
              <strong>3–7 business days</strong>, depending on the delivery
              location.
            </li>
            <li>
              Delivery timelines may vary due to courier operations or remote
              area access.
            </li>
          </ul>
        </section>

        <section className="mb-4">
          <h3
            className="text-gray-700"
            style={{ fontWeight: 600, fontSize: "20px" }}
          >
            Shipping Partners & Tracking
          </h3>
          <ul className="list-disc list-inside mb-4">
            <li>We ship orders using trusted courier partners.</li>
            <li>
              Shipment tracking details are shared with customers via email or
              SMS once the order is dispatched.
            </li>
          </ul>
        </section>

        <section className="mb-4">
          <h3
            className="text-gray-700"
            style={{ fontWeight: 600, fontSize: "20px" }}
          >
            Shipping Charges
          </h3>
          <ul className="list-disc list-inside mb-4">
            <li>
              Any applicable shipping charges are clearly displayed at checkout
              before payment confirmation.
            </li>
          </ul>
        </section>

        <section className="mb-4">
          <h3
            className="text-gray-700"
            style={{ fontWeight: 600, fontSize: "20px" }}
          >
            Cash on Delivery & Prepaid Orders
          </h3>
          <ul className="list-disc list-inside mb-4">
            <li>
              Availability of Cash on Delivery (COD) or prepaid options is shown
              at checkout, depending on serviceability.
            </li>
          </ul>
        </section>

        <section className="mb-4">
          <h3
            className="text-gray-700"
            style={{ fontWeight: 600, fontSize: "20px" }}
          >
            Delivery Delays
          </h3>
          <p>
            While we strive to meet the estimated delivery timelines, delays may
            occur due to unforeseen circumstances such as weather conditions,
            courier disruptions, or regional restrictions. We appreciate your
            patience in such cases.
          </p>
        </section>

        <section className="mb-4">
          <h3
            className="text-gray-700"
            style={{ fontWeight: 600, fontSize: "20px" }}
          >
            Customer Support
          </h3>
          <p>
            For any shipping-related queries, please contact us at {" "}
            <strong> support@{getBaseDomain(window.location.hostname)}.</strong>
          </p>
        </section>
      </div>

      <div className="text-center mt-6">
        <h3
          style={{
            fontSize: "18px",
            fontWeight: 700,
            color: "#727272",
            textAlign: "center",
          }}
        >
          Get Our Newsletter
        </h3>
        <div className="Footer__Content Rte">
          Subscribe to receive updates, access to exclusive deals, and more.
        </div>
        <Form
          method="post"
          id="footer-newsletter"
          acceptCharset="UTF-8"
          className="my-3"
          onSubmit={handleSubscribe}
        >
          <input type="hidden" name="form_type" value="customer" />
          <input type="hidden" name="utf8" value="✓" />
          <input type="hidden" name="contact[tags]" value="newsletter" />

          <Form.Control
            size="lg"
            type="email"
            placeholder="Enter email"
            className="mb-3"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          {!subscribed && (
            <Button
              type="submit"
              variant="dark"
              className="mt-3"
              style={{
                background: "var(--them-color)",
                borderColor: "var(--them-color)",
              }}
            >
              Subscribe
            </Button>
          )}

          {message && (
            <p style={{ color: "green", marginTop: "10px", fontWeight: 500 }}>
              {message}
            </p>
          )}
        </Form>
      </div>
    </Container>
  );
};

export default Shippingpolicy;
